import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TestDictionaryService {
    // eslint-disable-next-line
    constructor(http) {
        this.http = http;
    }
    getTestDictionarySuggested(lang) {
        return this.http.get(environment.api.base + 'tests/suggested?language=' + lang);
    }
    getTestDictionaryDetail(id) {
        return this.http.get(environment.api.base + 'tests/details?id=' + id);
    }
    addConfirmedParameter(id, isSuggested, data) {
        return this.http.post(environment.api.base + 'tests/details?id=' + id + '&isSuggested=' + isSuggested, data);
    }
    removeParameter(id, isSuggested, data) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: data,
        };
        return this.http.delete(environment.api.base + 'tests/parameters/' + id + '?isSuggested=' + isSuggested, options);
    }
}
TestDictionaryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TestDictionaryService_Factory() { return new TestDictionaryService(i0.ɵɵinject(i1.HttpClient)); }, token: TestDictionaryService, providedIn: "root" });
